module.exports = __webpack_public_path__ + "img/sala-de-juntas.56f2b209.jpg";